import type { i18n as I18n } from "i18next";

import { LANGUAGE_CODES, toLanguage } from "./languages";

/**
 * Once signed in, the editor speaks the language the account chose (the Account screen), whatever the browser or the
 * computer in use is in: someone travelling with a browser in English still reads their account in Spanish. Only a
 * new account (which has chosen nothing yet) starts in the browser's language: the API saves it at sign up.
 * Nothing changes when the account has no language the editor has.
 */
export const applyAccountLanguage = async (i18n: I18n, accountLanguage?: string | null) => {
  const base = (accountLanguage ?? "").toLowerCase().split(/[-_]/)[0];
  const language = LANGUAGE_CODES.find(code => code === base);
  if (language && language !== toLanguage(i18n.language)) {
    await i18n.changeLanguage(language);
  }
};
